export function formatAtlasMessageTimestamp(value: string | null | undefined): string {
  if (!value) {
    return '';
  }

  const parsed = new Date(value);
  if (isNaN(parsed.getTime())) {
    return '';
  }

  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit'
  }).format(parsed);
}

export function formatAtlasDateTime(value: string | null | undefined): string {
  if (!value) {
    return '-';
  }

  const parsed = new Date(value);
  if (isNaN(parsed.getTime())) {
    return value;
  }

  return new Intl.DateTimeFormat('en-DK', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(parsed);
}

export function formatDisplayDate(value: any): string | null {
  if (!value) {
    return null;
  }

  if (typeof value?.format === 'function') {
    return value.format('D MMM YYYY');
  }

  const parsedDate = new Date(value);
  if (isNaN(parsedDate.getTime())) {
    return null;
  }

  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  }).format(parsedDate);
}

export function serializeDateForAtlas(value: any): string | null {
  if (!value) {
    return null;
  }

  if (typeof value?.format === 'function') {
    return value.format('YYYY-MM-DD');
  }

  const parsedDate = new Date(value);
  if (isNaN(parsedDate.getTime())) {
    return null;
  }

  return parsedDate.toISOString().slice(0, 10);
}
